// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dFOD$dTypes$dClaimFODResult from "../Restaumatic.FOD.Types.ClaimFODResult/index.js";
import * as Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment from "../Restaumatic.Geocoding.Types.StreetAddressWithApartment/index.js";
import * as Restaumatic$dOrders$dRPC$dSites$dTypes from "../Restaumatic.Orders.RPC.Sites.Types/index.js";
import * as Restaumatic$dRestaurants$dTypes$dHolidayInfo from "../Restaumatic.Restaurants.Types.HolidayInfo/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dOrders$dRPC$dSites$dTypes.eqPaymentChannel.eq))();
const eq3 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dRestaurants$dTypes$dHolidayInfo.eqHolidayInfo.eq))();
const channelsIsSymbol = {reflectSymbol: () => "channels"};
const PaymentChannelsResponseIsSymbol = {reflectSymbol: () => "PaymentChannelsResponse"};
const isQrWaiterOrderIsSymbol = {reflectSymbol: () => "isQrWaiterOrder"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const GetOrderingAvailabilityRequestIsSymbol = {reflectSymbol: () => "GetOrderingAvailabilityRequest"};
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeInt1);
const decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Unscramble.decodeRecordNil);
const holidaysIsSymbol = {reflectSymbol: () => "holidays"};
const GetHolidaysResponseIsSymbol = {reflectSymbol: () => "GetHolidaysResponse"};
const GetHolidaysRequestIsSymbol = {reflectSymbol: () => "GetHolidaysRequest"};
const idIsSymbol = {reflectSymbol: () => "id"};
const resultIsSymbol = {reflectSymbol: () => "result"};
const ClaimFODResponseIsSymbol = {reflectSymbol: () => "ClaimFODResponse"};
const emailIsSymbol = {reflectSymbol: () => "email"};
const phoneIsSymbol = {reflectSymbol: () => "phone"};
const streetAddressIsSymbol = {reflectSymbol: () => "streetAddress"};
const ClaimFODRequestIsSymbol = {reflectSymbol: () => "ClaimFODRequest"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeRecordCons2 = /* #__PURE__ */ Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(restaurantIdIsSymbol)(encodeWithOptionsOther);
const encodeWithOptionsOther1 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeRecordCons4 = /* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(restaurantIdIsSymbol)(decodeWithOptionsOther)();
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const PaymentChannelsResponse = x => x;
const GetOrderingAvailabilityRequest = x => x;
const GetHolidaysResponse = x => x;
const GetHolidaysRequest = x => x;
const ClaimFODResponse = x => x;
const ClaimFODRequest = x => x;
const rPCMethodNameGetOrderingA = {rpcMethodName: v => "GetOrderingAvailabilityRequest"};
const rPCMethodNameGetHolidaysR = {rpcMethodName: v => "GetHolidaysRequest"};
const rPCMethodNameClaimFODRequ = {rpcMethodName: v => "ClaimFODRequest"};
const newtypePaymentChannelsRes = {Coercible0: () => {}};
const newtypeGetOrderingAvailab = {Coercible0: () => {}};
const newtypeGetHolidaysRespons = {Coercible0: () => {}};
const newtypeGetHolidaysRequest = {Coercible0: () => {}};
const newtypeClaimFODResponse_ = {Coercible0: () => {}};
const newtypeClaimFODRequest_ = {Coercible0: () => {}};
const hasFieldPaymentChannelsRe = dictHasField => dictHasField;
const hasFieldGetOrderingAvaila = dictHasField => dictHasField;
const hasFieldGetHolidaysRespon = dictHasField => dictHasField;
const hasFieldGetHolidaysReques = dictHasField => dictHasField;
const hasFieldClaimFODResponse = dictHasField => dictHasField;
const hasFieldClaimFODRequest = dictHasField => dictHasField;
const eqPaymentChannelsResponse = {eq: x => y => eq(x.channels)(y.channels)};
const eqGetOrderingAvailability = {eq: x => y => x.isQrWaiterOrder === y.isQrWaiterOrder && x.restaurantId === y.restaurantId};
const eqGetHolidaysResponse = {eq: x => y => eq3(x.holidays)(y.holidays)};
const eqGetHolidaysRequest = {eq: x => y => x.restaurantId === y.restaurantId};
const eqClaimFODResponse = {eq: x => y => x.id === y.id && Restaumatic$dFOD$dTypes$dClaimFODResult.eq(x.result)(y.result)};
const eqClaimFODRequest = {
  eq: x => y => x.email === y.email && x.phone === y.phone && x.restaurantId === y.restaurantId && (() => {
    if (x.streetAddress.tag === "Nothing") { return y.streetAddress.tag === "Nothing"; }
    if (x.streetAddress.tag === "Just") {
      if (y.streetAddress.tag === "Just") {
        return (() => {
          if (x.streetAddress._1.apartmentNumber.tag === "Nothing") { return y.streetAddress._1.apartmentNumber.tag === "Nothing"; }
          if (x.streetAddress._1.apartmentNumber.tag === "Just") {
            if (y.streetAddress._1.apartmentNumber.tag === "Just") { return x.streetAddress._1.apartmentNumber._1 === y.streetAddress._1.apartmentNumber._1; }
            return false;
          }
          return false;
        })() && x.streetAddress._1.city === y.streetAddress._1.city && x.streetAddress._1.street === y.streetAddress._1.street && x.streetAddress._1.streetNumber === y.streetAddress._1.streetNumber;
      }
      return false;
    }
    return false;
  })()
};
const genericPaymentChannelsResponse = {to: x => x, from: x => x};
const showPaymentChannelsResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dOrders$dRPC$dSites$dTypes.showPaymentChannel.show);
      return {genericShowArgs: v => ["{ channels: " + $0(v.channels) + " }"]};
    })())(PaymentChannelsResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodePaymentChannelsResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(channelsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dOrders$dRPC$dSites$dTypes.unscrambleDecodePaymentChannel.unsafeDecode)
    })(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGetOrderingAvailabilityRequest = {to: x => x, from: x => x};
const showGetOrderingAvailabilityRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ isQrWaiterOrder: " + (v.isQrWaiterOrder ? "true" : "false") + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " " + "}"]
    })(GetOrderingAvailabilityRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetOrderingAvailabilityRequest = /* #__PURE__ */ (() => (
  {unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(isQrWaiterOrderIsSymbol)(Unscramble.decodeBoolean1)(decodeRecordCons1).recordInfo(Type$dProxy.Proxy))}
))();
const genericGetHolidaysResponse = {to: x => x, from: x => x};
const showGetHolidaysResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dRestaurants$dTypes$dHolidayInfo.showHolidayInfo.show);
      return {genericShowArgs: v => ["{ holidays: " + $0(v.holidays) + " }"]};
    })())(GetHolidaysResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetHolidaysResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(holidaysIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dRestaurants$dTypes$dHolidayInfo.unscrambleDecodeHolidayInfo.unsafeDecode)
    })(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGetHolidaysRequest = {to: x => x, from: x => x};
const showGetHolidaysRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " }"]})(GetHolidaysRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetHolidaysRequest = /* #__PURE__ */ (() => ({unsafeDecode: Unscramble.decodeRecord(decodeRecordCons1.recordInfo(Type$dProxy.Proxy))}))();
const genericClaimFODResponse = {to: x => x, from: x => x};
const showClaimFODResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ id: " + Data$dShow.showStringImpl(v.id) + ", result: " + Restaumatic$dFOD$dTypes$dClaimFODResult.showClaimFODResult.show(v.result) + " " + "}"]
    })(ClaimFODResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(idIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(resultIsSymbol)(Restaumatic$dFOD$dTypes$dClaimFODResult.unscrambleDecodeClaimFODResult)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericClaimFODRequest = {to: x => x, from: x => x};
const showClaimFODRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ email: " + Data$dShow.showStringImpl(v.email) + ", phone: " + Data$dShow.showStringImpl(v.phone) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + (() => {
          if (v.streetAddress.tag === "Just") {
            return ", streetAddress: (Just " + Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.showStreetAddressWithApartment.show(v.streetAddress._1) + ") ";
          }
          if (v.streetAddress.tag === "Nothing") { return ", streetAddress: Nothing "; }
          $runtime.fail();
        })() + "}"
      ]
    })(ClaimFODRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(emailIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(phoneIsSymbol)(Unscramble.decodeString1)(decodeRecordCons(Unscramble.decodeRecordCons(streetAddressIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.unscrambleDecodeStreetAddressWithApartment))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodePaymentChannelsResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPaymentChannelsResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(PaymentChannelsResponseIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(channelsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dOrders$dRPC$dSites$dTypes.encodePaymentChannel.encode);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetOrderingAvailabilityRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetOrderingAvailabilityRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(encodeRecordCons2)(isQrWaiterOrderIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetHolidaysResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetHolidaysResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetHolidaysResponseIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(holidaysIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dRestaurants$dTypes$dHolidayInfo.encodeHolidayInfo.encode);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetHolidaysRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetHolidaysRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetHolidaysRequestIsSymbol)({
    encodeArgs: opts => v => Data$dList$dTypes.$List(
      "Cons",
      Foreign$dGeneric$dClass.$Arg("RecArg", encodeRecordCons2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
      Data$dList$dTypes.Nil
    )
  }))
};
const encodeClaimFODResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericClaimFODResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ClaimFODResponseIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(resultIsSymbol)({
      encodeWithOptions: v => Restaumatic$dFOD$dTypes$dClaimFODResult.encodeClaimFODResult.encode
    }))(idIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeClaimFODRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericClaimFODRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ClaimFODRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetAddressIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.encodeStreetAddressWithApartment.encode(v2._1); }
        $runtime.fail();
      }
    }))(restaurantIdIsSymbol)(encodeWithOptionsOther))(phoneIsSymbol)(encodeWithOptionsOther1))(emailIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodePaymentChannelsResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPaymentChannelsResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PaymentChannelsResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(channelsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dOrders$dRPC$dSites$dTypes.decodePaymentChannel).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetOrderingAvailabilityRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetOrderingAvailabilityRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetOrderingAvailabilityRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(decodeRecordCons4)(isQrWaiterOrderIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetHolidaysResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetHolidaysResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetHolidaysResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(holidaysIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dRestaurants$dTypes$dHolidayInfo.decodeHolidayInfo).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetHolidaysRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetHolidaysRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetHolidaysRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(decodeRecordCons4)))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeClaimFODResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericClaimFODResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ClaimFODResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(resultIsSymbol)({
    decodeWithOptions: v => Restaumatic$dFOD$dTypes$dClaimFODResult.decodeClaimFODResult.decode
  })())(idIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeClaimFODRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericClaimFODRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ClaimFODRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetAddressIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dStreetAddressWithApartment.decodeStreetAddressWithApartment.decode)
  })())(restaurantIdIsSymbol)(decodeWithOptionsOther)())(phoneIsSymbol)(decodeWithOptionsOther1)())(emailIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ClaimFODRequest,
  ClaimFODRequestIsSymbol,
  ClaimFODResponse,
  ClaimFODResponseIsSymbol,
  GetHolidaysRequest,
  GetHolidaysRequestIsSymbol,
  GetHolidaysResponse,
  GetHolidaysResponseIsSymbol,
  GetOrderingAvailabilityRequest,
  GetOrderingAvailabilityRequestIsSymbol,
  PaymentChannelsResponse,
  PaymentChannelsResponseIsSymbol,
  channelsIsSymbol,
  decodeClaimFODRequest,
  decodeClaimFODResponse,
  decodeGetHolidaysRequest,
  decodeGetHolidaysResponse,
  decodeGetOrderingAvailabilityRequest,
  decodePaymentChannelsResponse,
  decodeRecordCons,
  decodeRecordCons1,
  decodeRecordCons4,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  emailIsSymbol,
  encodeClaimFODRequest,
  encodeClaimFODResponse,
  encodeGetHolidaysRequest,
  encodeGetHolidaysResponse,
  encodeGetOrderingAvailabilityRequest,
  encodePaymentChannelsResponse,
  encodeRecordCons2,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  eq,
  eq3,
  eqClaimFODRequest,
  eqClaimFODResponse,
  eqGetHolidaysRequest,
  eqGetHolidaysResponse,
  eqGetOrderingAvailability,
  eqPaymentChannelsResponse,
  genericClaimFODRequest,
  genericClaimFODResponse,
  genericGetHolidaysRequest,
  genericGetHolidaysResponse,
  genericGetOrderingAvailabilityRequest,
  genericPaymentChannelsResponse,
  hasFieldClaimFODRequest,
  hasFieldClaimFODResponse,
  hasFieldGetHolidaysReques,
  hasFieldGetHolidaysRespon,
  hasFieldGetOrderingAvaila,
  hasFieldPaymentChannelsRe,
  holidaysIsSymbol,
  idIsSymbol,
  isQrWaiterOrderIsSymbol,
  newtypeClaimFODRequest_,
  newtypeClaimFODResponse_,
  newtypeGetHolidaysRequest,
  newtypeGetHolidaysRespons,
  newtypeGetOrderingAvailab,
  newtypePaymentChannelsRes,
  phoneIsSymbol,
  rPCMethodNameClaimFODRequ,
  rPCMethodNameGetHolidaysR,
  rPCMethodNameGetOrderingA,
  restaurantIdIsSymbol,
  resultIsSymbol,
  showClaimFODRequest,
  showClaimFODResponse,
  showGetHolidaysRequest,
  showGetHolidaysResponse,
  showGetOrderingAvailabilityRequest,
  showPaymentChannelsResponse,
  streetAddressIsSymbol,
  unscrambleDecodeClaimFODRequest,
  unscrambleDecodeClaimFODResponse,
  unscrambleDecodeGetHolidaysRequest,
  unscrambleDecodeGetHolidaysResponse,
  unscrambleDecodeGetOrderingAvailabilityRequest,
  unscrambleDecodePaymentChannelsResponse
};
